import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';

import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-offer-select-dialog',
    templateUrl: './offer-select-dialog.component.html',
    styleUrls: ['./offer-select-dialog.component.scss'],
    standalone: false
})
export class OfferSelectDialogComponent {
	$storage: any;
	total: number = 0;
	totalOrderDiscount: number = 0;

	offers: {
		id: string,
		name: string;
		price: number;
		selected: boolean;
	}[];

	@ViewChild('list') list: MatSelectionList;

	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<OfferSelectDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.$storage = this.data.$storage;
		const selectedOffers = _.map(this.data.selectedOffers, o => o.id);
		this.offers = []; let id = 0;

		this.totalOrderDiscount = this.$storage.order.printData.variables?.TOTAL_ORDER_DISCOUNTS || 0;
		let offerTotal = 0;

		debugger

		_.each(this.$storage.order.printData.collections.ORDERED_OFFERS_LIST, (offer, index) => {
			const base_id = `${++id}`;
			let total = 0, roundTo = this.appService.regionArgs.decimals;
			let summary: any = [];
			_.each(offer.ALL_ORDERED_ITEMS, offerItem => {
				if (offerItem.ITEM_PRICE) {
					summary.push ({name: offerItem.ITEM_NAME, price: offerItem.ITEM_PRICE})
				} else {
					_.each( offerItem.MODIFIERS_LIST, modItem => {
						if (modItem.MODIFIER_PRICE) {
							summary.push({name: modItem.MODIFIER_NAME, price: modItem.MODIFIER_PRICE});
						}
					});
				}
			});
			if (!summary.length) {
				summary = null;
			}
			for (let i = 0; i < offer.OFFER_QTY; i++) {
				if (offer.ON_THE_HOUSE) continue;
				let realPrice = offer.OFFER_AMOUNT / offer.OFFER_QTY;
				let discounts = _.sumBy(offer.ORDERED_OFFER_DISCOUNTS, 'DISCOUNT_AMOUNT') / offer.OFFER_QTY;
				let price = _.round(realPrice - discounts, roundTo);
				offerTotal += price;

				if (price <= 0) continue;
				total += price;

				const id = `${base_id}_${i}`;
				const selected = selectedOffers.includes(id);
				if (i > 0 && i == (offer.OFFER_QTY - 1)) {
					if (offer.OFFER_AMOUNT < total) price += _.round(total - offer.OFFER_AMOUNT, roundTo)
				}
				const _offer:any = {
					id: id,
					name: offer.OFFER_NAME,
					price: price,
					selected: selected,
					summary: summary
				}
				if (discounts) _offer.originalPrice = _.round(realPrice, roundTo);
				this.offers.push(_offer);
				if (selected) {
					this.total += _offer.price;
				}
			}
		});

		if (this.totalOrderDiscount) {
			this.offers.forEach((o: any) => {
				const p = o.price / offerTotal;
				const discount = p * this.totalOrderDiscount;
				if (discount > 0.5) {
					if (!o.originalPrice) o.originalPrice = o.price;
					else o.originalPrice -= discount;
				}
				o.price -= discount;
			});
		}

	}

	cancel() {
		this.dialogRef.close();
	}
	onOfferSelected(list, ev) {
		if (ev) ev.stopPropagation();
		setTimeout(() => {
			let total = 0;
			list.selectedOptions.selected.forEach(item => {
				if (item.value.price) {
					total += item.value.price;
				}
			});
			this.total = total;
		}, 100);
	}

	apply() {
		this.dialogRef.close({
			amount: this.total,
			selectedOffers: this.list.selectedOptions.selected.map(o => o.value),
		});
	}

}
